import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { Plan } from "./plan.interface";
import { PlanService } from "./plan.service";
import { ToastrService } from "../shared/toastr.service";

@Component({
  selector: "app-plan",
  templateUrl: "./plan.component.html",
  styleUrls: ["./plan.component.scss"],
  standalone: false,
})
export class PlanComponent implements OnInit {
  buying = false;
  plans: Observable<Plan[]>;

  constructor(
    private planService: PlanService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.plans = this.planService.getAll();
  }

  buy = (id: string) =>
    new Promise((res) => res((this.buying = true)))
      .then(() => this.planService.buy(id).toPromise())
      .then((r: { id: string } | undefined) => {
        if (r) {
          return this.planService.redirectToCheckout(r.id);
        }
      })
      .catch(() => this.toastr.error("Can not buy plan"))
      .finally(() => (this.buying = false));
}
